import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';
import { getProductEnrichmentHistory } from '~/features/catalog-operations/services/catalog-operations.service';

/** Integrations connector code → the workflow-service code that picks the enrichment table. */
const ENRICHMENT_CONNECTOR: Record<string, string> = {
  GOOGLE_MERCHANT: 'GMC',
  META_COMMERCE: 'META',
};

/** Fetches every enrichment run for one catalog product (newest first) for the
 *  Product Catalog detail panel. Disabled until the product's external id is known. */
export function useCatalogEnrichmentHistory(
  externalId: string,
  catalogConnectorCode: string,
  enabled = true,
) {
  const connectorCode = ENRICHMENT_CONNECTOR[catalogConnectorCode];
  return useQuery({
    queryKey: queryKeys.catalogOperations.productEnrichmentHistory(externalId, connectorCode),
    queryFn: () => getProductEnrichmentHistory(externalId, connectorCode),
    enabled: enabled && !!externalId,
  });
}
